import { apiGet, apiPatch } from './client';
import type { Continent, ContinentBatchRequest } from '../types/Continent';

export function getContinents(): Promise<Continent[]> {
  return apiGet<Continent[]>('/api/continents');
}

export function saveBatchContinents(
  added: Continent[],
  modified: Continent[],
  deletedIds: number[],
): Promise<Continent[]> {
  return apiPatch<ContinentBatchRequest, Continent[]>(
    '/api/continents/batch',
    { added, modified, deleted: deletedIds },
  );
}
